<iu-banner *ngIf="mustRefresh" type="message"> Vos données doivent être rafraîchie. </iu-banner>
<iu-banner *ngIf="hasConflicts && remoteData && localData" type="error">
  Des conflits sont présents dans vos données.
  <a style="text-decoration: underline; cursor: pointer" (click)="wantToMergeConflicts = true">Vérifier</a> et
  sauvegarder.
</iu-banner>
<div id="{{ scrollPanelid }}" class="p-col dynamicContainer"><ng-template iuDynamicContainer></ng-template></div>
